var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "leads-section-wrapper" }, [
    _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("message.leads")))]),
    ]),
    _vm._v(" "),
    _vm.leads.length
      ? _c(
          "div",
          { staticClass: "leads-section" },
          _vm._l(_vm.leads, function (lead) {
            return _c(
              "div",
              { key: lead.id, staticClass: "lead-row" },
              [
                _c("div", { staticClass: "lead-info" }, [
                  _c("div", { staticClass: "lead-name" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(lead.Full_Name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lead-date" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("event"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDate(lead.Created_Time))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lead-footer" }, [
                    _c("div", { staticClass: "lead-owner" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(lead.Owner.name))]),
                    ]),
                    _vm._v(" "),
                    lead.Lead_Status
                      ? _c("div", { staticClass: "lead-status" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("label"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(lead.Lead_Status))]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lead-layout" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("category"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(lead, "Layout.name", "Defualt Layout")
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("SupsisButton", {
                  staticClass: "view-lead-btn",
                  attrs: { icon: "open_in_new" },
                  on: {
                    click: function ($event) {
                      return _vm.gotoLeadOnZoho(lead.id)
                    },
                  },
                }),
                _vm._v(" "),
                _c("a-divider"),
              ],
              1
            )
          }),
          0
        )
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("span", [_vm._v("Loading leads")]),
            _vm._v(" "),
            _c("BucketSpinner", { staticClass: "large-spinner" }),
          ],
          1
        )
      : _c("div", { staticClass: "empty-leads-container" }, [
          _c("span", { staticClass: "material-icons empty-icon" }, [
            _vm._v("person_off"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "empty-text" }, [
            _vm._v(_vm._s(_vm.$t("message.noLeadsFound"))),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }